import { render, staticRenderFns } from "./TooltipRisikoanalyse.vue?vue&type=template&id=3edc0034&scoped=true&"
import script from "./TooltipRisikoanalyse.vue?vue&type=script&lang=js&"
export * from "./TooltipRisikoanalyse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edc0034",
  null
  
)

export default component.exports